import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { useCphContext } from "../../hooks/useCphContext";
import { useCphDataContext } from "../../hooks/useCphDataContext";
import { formatDateNumericDateAndHour } from "../../../global/utilities/DateFormatter";

const IssueOverviewCard: React.FC = () => {
    const { selectedIssue } = useCphDataContext();
    const { isStaff } = useCphContext();

    if (!selectedIssue) {
        return <Typography variant="body1">No issue selected.</Typography>;
    }

    const payerIssues = selectedIssue.payerIssues ?? [];
    const codingIssues = selectedIssue.codingIssues ?? [];
    const isPayerIssue = payerIssues.length > 0;
    const isCodingIssue = codingIssues.length > 0;

    return (
        <Card sx={{ width: '100%', height: '100%', maxWidth: '100%', mx: 0, px: 0, py: 0 }}>
            <CardContent>
                <Typography variant="body2">
                    <strong>Reporter:</strong> {selectedIssue.reporter?.lastName}, {selectedIssue.reporter?.firstName}
                </Typography>
                <Typography variant="body2">
                    <strong>Organization Type:</strong> {selectedIssue.demographicData?.orgType}
                </Typography>
                <Typography variant="body2">
                    <strong>Reporter Email:</strong> {selectedIssue.reporter?.email}
                </Typography>
                <Typography variant="body2">
                    <strong>State:</strong> {selectedIssue.reporter?.state}
                </Typography>
                <Typography variant="body2">
                    <strong>Chapter:</strong> {selectedIssue.reporter?.chapter ?? "No active chapter"}
                </Typography>
                <Typography variant="body2">
                    <strong>Specialty:</strong> {selectedIssue.demographicData?.specialty}
                </Typography>
                {selectedIssue.demographicData?.subSpecialty != null && (
                    <Typography variant="body2">
                        <strong>Sub-Specialty:</strong> {selectedIssue.demographicData?.subSpecialty}
                    </Typography>
                )}

                <Typography variant="body2">
                    <strong>Payer Related:</strong> {isPayerIssue ? "Yes" : "No"}
                </Typography>
                {isPayerIssue && (
                    <>
                        <Typography variant="body2">
                            <strong>Payer Name:</strong> {payerIssues[0].payerName}
                        </Typography>
                        
                        <Typography variant="body2">
                            <strong>Payer Type:</strong> {payerIssues[0].payerType}
                        </Typography>

                        <Typography variant="body2" component="div">
                            <strong>Payer Issues:</strong>
                            <ul style={{ marginTop: 4, marginBottom: 0 }}>
                                {payerIssues.map((payerIssue, index) => (
                                    <li key={payerIssue.payerIssueKey ?? payerIssue.issueKey ?? `${index}`}>
                                        {payerIssue.payerIssue || ""}
                                        {payerIssue.payerIssueOther ? ` - ${payerIssue.payerIssueOther}` : ""}
                                    </li>
                                ))}
                            </ul>
                        </Typography>
                    </>
                )}

                {isCodingIssue && (
                    <Typography variant="body2" component="div">
                        <strong>Coding Issues:</strong>
                        <ul style={{ marginTop: 4, marginBottom: 0 }}>
                            {codingIssues.map((codingIssue, index) => (
                                <li key={codingIssue.codingIssueKey ?? codingIssue.issueKey ?? `${index}`}>
                                    {codingIssue.name || ""}
                                </li>
                            ))}
                        </ul>
                    </Typography>
                )}


                <Typography variant="body2">
                    <strong>Status:</strong> {selectedIssue.status?.status}
                </Typography>
                <Typography variant="body2">
                    <strong>Date Opened:</strong> {formatDateNumericDateAndHour(selectedIssue.status?.dateCreated)}
                </Typography>
                <Typography variant="body2">
                    <strong>Date Last Modified:</strong> {formatDateNumericDateAndHour(selectedIssue.status?.lastModifiedDate || selectedIssue.status?.dateCreated)}
                </Typography>
                <Typography variant="body2">
                    <strong>Date Closed:</strong> {formatDateNumericDateAndHour(selectedIssue.status?.closedDate)}
                </Typography>
                {selectedIssue.status?.closedBy != null && isStaff && (
                    <Typography variant="body2">
                        <strong>Closed By:</strong> {selectedIssue.status.closedBy.firstName} {selectedIssue.status.closedBy.lastName}
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
};

export default IssueOverviewCard;
